export default "__VITE_ASSET__714a7db2__"